var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (Boolean(_vm.asset.trainingComplete) || !_vm.isLoading)?_c('checkbox',{attrs:{"value":Boolean(_vm.asset.trainingComplete),"disabled":Boolean(_vm.asset.trainingComplete)},on:{"input":_vm.update}},[_vm._v(_vm._s(_vm.$t("I've completed the certificate")))]):_c('div',[_vm._v(_vm._s(_vm.$t('Loading...')))])
}
var staticRenderFns = []

export { render, staticRenderFns }